import type React from 'react';
import { useEffect } from 'react';

//Types
import type { OpenUrlComponent } from 'api/types';

//utils
import { isSafari } from '../../utils/helpers';
import { THREE_SECONDS } from 'components/App/consts';

interface OpenUrlStepProps {
  widgetComponent: OpenUrlComponent;
}

const OpenUrlStep: React.FC<React.PropsWithChildren<OpenUrlStepProps>> = ({
  widgetComponent,
}) => {
  const url = widgetComponent.component_fields.url;

  useEffect(() => {
    const redirectUser = () => {
      if (isSafari()) {
        const Window = window.open('');
        Window?.location.assign(url);
      } else {
        window.open(url, '_blank', 'noopener');
      }
    };

    const timer = setTimeout(redirectUser, THREE_SECONDS);
    return () => clearTimeout(timer);
  }, []);

  return null;
};

export default OpenUrlStep;
